import React, { type ReactNode } from 'react';
import noop from 'lodash/noop';

type Props = {
	enabled?: boolean;
	href: string;
	children: ReactNode;
	onClick?: () => void;
};

export const ExternalLink = ({ enabled = true, href, children = null, onClick = noop }: Props) =>
	enabled ? (
		<a rel="noreferrer" href={href} target="_blank" onClick={onClick}>
			{children}
		</a>
	) : (
		<>{children}</>
	);
